import { useEffect } from "react";
import { useLocation } from "react-router";
import { useHelpDrawer } from "src/contexts/HelpDrawerContext";
import useRouteHelp from "src/hooks/useRouteHelp";

export default function HelpRouteSync() {
    const location = useLocation();
    const topicKey = useRouteHelp();
    const { syncRoute } = useHelpDrawer();
    useEffect(() => {
        syncRoute(topicKey, location.state?.helpNavigationToken);
    }, [location.key, location.pathname, location.search, topicKey, syncRoute]);
    return null;
}
